<template>
    <div class="container remove-padding-margin">

        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                        <div class="remove-margin">Debug Info</div>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 mar-top-60">
                    <div class="font-18 line-height-25 letter-space-002 color-0000 font-weight-600 mar-top-16 mar-bottom-20 d-flex align-items-center">
                        <div class="row m-0 w-100 d-flex align-items-center">
                            <div class="col-8 p-0">
                              Email :
                                <div>
                                    {{email_local}}
                                </div>
                                <input type="text" class="w-100" readonly style="border: none; outline: none"
                                       :value="email_owner" id="copied_email">
                            </div>
                            <div class="col-4 text-right p-0">
                                <button class="btn btn-outline-primary" @click="copyToClipboard('copied_email')">Salin</button>
                            </div>
                        </div>
                    </div>
                    <div class="font-18 line-height-25 letter-space-002 color-0000 font-weight-600 mar-top-16 mar-bottom-20 d-flex align-items-center">
                        <div class="row m-0 w-100 d-flex align-items-center">
                            <div class="col-8 p-0">
                                Token :
                                <div style="overflow-wrap: break-word">
                                    {{token_owner}}
                                </div>
                                <input type="text" class="w-100" readonly style="border: none; outline: none; opacity: 0;"
                                       :value="token_owner" id="token_app" >
                            </div>
                            <div class="col-4 text-right p-0">
                                <button class="btn btn-outline-primary" @click="copyToClipboard('token_app')">Salin</button>
                            </div>
                        </div>
                    </div>
                    <div class="font-18 line-height-25 letter-space-002 color-0000 font-weight-600 mar-top-16 mar-bottom-20 d-flex align-items-center">
                        <div class="row m-0 w-100 d-flex align-items-center">
                            <div class="col-8 p-0">
                                Token :
                                <div style="overflow-wrap: break-word">
                                    {{browser}}
                                </div>
                                <input type="text" class="w-100" readonly style="border: none; outline: none; opacity: 0;"
                                       :value="browser" id="browser_app" >
                            </div>
                            <div class="col-4 text-right p-0">
                                <button class="btn btn-outline-primary" @click="copyToClipboard('browser_app')">Salin</button>
                            </div>
                        </div>
                    </div>



                    <!--<div v-if="status_password ==='tidak_ada'">-->
                    <div>
                        <button type="button" class="btn btn-outline-primary btn-long mar-bot-12" id="btn1" @click="sendWaData">Kirim data ke Whatsapp CS</button>
                    </div>
                </div>
            </div>
        </main>



    </div>
</template>

<script>
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "DebugApp",
        components: { ErrorMessage },
        data(){
            return{
                telp:'',
                owner:{},
                email_owner:'',
                token_owner:localStorage.getItem('token'),
                email_local:localStorage.getItem('email'),
                idowner:localStorage.getItem('idowner'),
                browser:navigator.userAgent,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },

        mounted(){
            this.getdetailowner()
        },
        methods: {
            copyToClipboard(id) {
                var copyText = document.getElementById(id);
                copyText.select();
                copyText.setSelectionRange(0, 99999)
                document.execCommand("copy");

                this.$toast.success("data tersailn")
            },

            back() {
                this.$router.push('/detailakunowner')
            },

            sendWaData(){
                window.location.href = "https://api.whatsapp.com/send/?phone=6285234494494&text=Halo%20SmartCare" +
                    "%2C%0Aini%20data%20debug%20saya%20" +
                    "%20%3A%0AEmail%20%3A%20" +this.email_owner+
                    "%0Aemail%20%3A%20" +this.token_owner+
                    "%20%0AID%20%3A%20" +this.idowner+
                    "%20%0ABrowser%20%3A%20" +this.browser+
                    "%20%0A%0A";

            },

            async getdetailowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner',  this.requestHeaders);
                    this.owner = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');

                        // $('#loadingPage').hide();
                        var dataowner = res.data.data
                        this.set_password = res.data.set_password
                        this.email_owner = dataowner.email
                    }else{
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },


        }
    }
</script>

<style scoped>

</style>